import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import { MdVideoLibrary, MdImage } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";

const CardCarousel = ({ id, url, title, type, onDelete }) => {
  const navigate = useNavigate();
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`/api_w/carousels/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      onDelete(id);
      toast.success("Berhasil Hapus Carousel");
    } catch (error) {
      toast.error("Error Hapus Carousel: " + (error.response?.data?.message || error.message));
    } finally {
      setShowDeletePrompt(false);
    }
  };

  const renderMedia = () => {
    if (type === "image") {
      return <img className="h-44 w-full object-cover" src={url} alt={title} />;
    } else if (type === "video") {
      const youtubeMatch = url.match(
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
      );
      const gdriveMatch = url.match(/drive\.google\.com\/file\/d\/([^\/]+)\//); 
      let videoUrl = url;
      if (youtubeMatch) videoUrl = `https://www.youtube.com/embed/${youtubeMatch[1]}`;
      else if (gdriveMatch) videoUrl = `https://drive.google.com/file/d/${gdriveMatch[1]}/preview`;
      return (
        <iframe className="h-44 w-full" src={videoUrl} title={title} frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }
    return <div className="h-44 w-full bg-gray-100 flex items-center justify-center"><span className="text-gray-400">No media</span></div>;
  };

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-sm border border-gray-100 dark:bg-navy-700 dark:border-navy-600">
      {/* Media Thumbnail */}
      <div className="relative overflow-hidden">
        {renderMedia()}
        <span className={`absolute top-3 left-3 inline-flex items-center gap-1 rounded-lg px-2.5 py-1 text-xs font-semibold ${
          type === "video" ? "bg-purple-50 text-purple-600" : "bg-blue-50 text-blue-600"
        }`}>
          {type === "video" ? <MdVideoLibrary className="h-3.5 w-3.5" /> : <MdImage className="h-3.5 w-3.5" />}
          {type === "video" ? "Video" : "Gambar"}
        </span>
      </div>

      {/* Card Body */}
      <div className="p-4">
        <h3 className="font-semibold text-navy-700 dark:text-white line-clamp-1 mb-3">{title}</h3>
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(`/admin/edit-carousel/${id}`)}
            className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-blue-50 py-2 text-xs font-medium text-blue-600 hover:bg-blue-100 transition-colors"
          >
            <FaEdit className="h-3.5 w-3.5" /> Edit
          </button>
          <button
            onClick={() => setShowDeletePrompt(true)}
            className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-red-50 py-2 text-xs font-medium text-red-500 hover:bg-red-100 transition-colors"
          >
            <FaTrash className="h-3.5 w-3.5" /> Hapus
          </button>
        </div>
      </div>

      {/* Delete Modal */}
      {showDeletePrompt && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
              <FaTrash className="h-5 w-5 text-red-500" />
            </div>
            <h3 className="mb-2 text-lg font-bold text-navy-700">Hapus Carousel?</h3>
            <p className="mb-6 text-sm text-gray-500">Apakah anda yakin ingin menghapus carousel ini?</p>
            <div className="flex gap-3">
              <button onClick={() => setShowDeletePrompt(false)} className="flex-1 rounded-xl border border-gray-200 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50">
                Batal
              </button>
              <button onClick={handleConfirmDelete} className="flex-1 rounded-xl bg-red-500 py-2.5 text-sm font-bold text-white hover:bg-red-600">
                Hapus
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardCarousel;
